/**
 * 缓存父路由mixin
 */
import cache from '../common/cache'

const mixin = {
  created () {
    const route = this.$route
    if (!route.meta.isParent) {
      return
    }

    // 当前父路由信息
    const key = route.matched[0].path
    const value = {
      meta: route.meta,
      params: route.params,
      path: route.path,
      query: route.query
    }

    // 存储
    let cacheRoutes = cache.getLocalStorageData('cacheRoutes') || {}
    cacheRoutes[key] = value
    cache.setLocalStorageData('cacheRoutes', cacheRoutes)
  },

  computed: {
    $cacheRoute () {
      // 当前是父路由页面
      if (this.$route.matched.length === 1) {
        return this.$route
      }

      // 非父路由页面
      const key = this.$route.matched[0].path
      const cacheRoutes = cache.getLocalStorageData('cacheRoutes') || {}
      return cacheRoutes[key] || this.$route
    }
  }
}

export default mixin
